module.exports = __webpack_public_path__ + "static/media/art-medieval.fcc7adeb.jpg";